const _excluded = ["title", "titleId"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}
import * as React from "react";
function Svg03IconoFotoPerfil(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 42.79 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#f5f4ff;fill-rule:evenodd;}.cls-2{fill:#202832;}")), /*#__PURE__*/React.createElement("g", {
    id: "Capa_2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Capa_2-2",
    "data-name": "Capa 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "User"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fondo",
    className: "cls-1",
    d: "M21.4,43A21.5,21.5,0,1,0,0,21.5,21.45,21.45,0,0,0,21.4,43Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M21.53,20.69a6.64,6.64,0,1,1,6.55-6.64A6.61,6.61,0,0,1,21.53,20.69Zm0-12a5.41,5.41,0,1,0,5.32,5.41A5.38,5.38,0,0,0,21.53,8.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M33.45,32H32.23a10.71,10.71,0,1,0-21.41,0H9.6a11.93,11.93,0,1,1,23.85,0Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03IconoFotoPerfil);
export default __webpack_public_path__ + "static/media/03_Icono Foto Perfil.7324cc0c8ef6a13b7ce7b4f7e6e209f5.svg";
export { ForwardRef as ReactComponent };